import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_layout/settings/_panel/quoting/tax-rates/$taxRateId/",
)({
  component: Empty,
})

function Empty(): React.ReactElement {
  return <span />
}
